import type { ReactNode } from 'react';
import { useTranslation, useProperty } from '@eti/providers';
import { Badge, Inline } from '@etg/wings';
import { css } from '@eti/styles';
import type { Maybe, TripTag } from '@eti/schema-types';
import { TripCharacteristics } from '@eti/schema-types';
import { getTripTagsTitle } from '../../../../utils/resultUtils';

interface TripTagsProps {
  tripTags?: Maybe<Array<Maybe<TripTag>>>;
  tripCharacteristics?: Maybe<Array<Maybe<TripCharacteristics>>>;
  isOneWay?: boolean;
}

const tripTagTitleStyles = css`
  border-radius: 8px;
  margin: auto;
  padding: 4px 8px;
`;

export const TripTagTitle = ({ children }: { children: ReactNode }) => (
  <Badge className={tripTagTitleStyles}>{children}</Badge>
);

export const tripTagsWrapper = css`
  padding: 8px 16px 0;
`;

export const TripTags = ({ tripTags, tripCharacteristics, isOneWay = false }: TripTagsProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const tripTitlesArray = getTripTagsTitle(tripTags, t, isOneWay)
    .split(' | ')
    .filter((tag: string) => tag);
  const isValidWithVoucher =
    p('Result.SelfServiceRebooking.ValidWithVoucherTag.Enable') &&
    tripCharacteristics?.includes(TripCharacteristics.ValidWithVoucher);

  if (isValidWithVoucher) {
    tripTitlesArray.push(t('Result.SSR.ValidVoucher.Text'));
  }

  return tripTitlesArray?.map((tag: TripTag) => (
    <Inline key={tag}>
      <TripTagTitle>{tag}</TripTagTitle>
    </Inline>
  ));
};
